/*
 * Jira Ticket:
 * Created Date: Fri, 13th Mar 2020, 15:47:15 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import gql from 'graphql-tag';

export const termsAndConditionsQuery = gql`
  query termsAndConditions {
    data: termsAndConditions
  }
`;

const termsAndConditions = async ({ publicClient }) => {
  try {
    const response = await publicClient.query({
      query: termsAndConditionsQuery,
      fetchPolicy: 'network-only',
    });
    return response.data;
  } catch (e) {
    if (e.graphQLErrors && e.graphQLErrors.length) {
      const [error] = e.graphQLErrors;
      const message = error.message;
      throw new Error(message);
    }
    throw e;
  }
};

export default termsAndConditions;
